import {FC, SVGProps} from "react";

interface IErrorIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const ErrorIcon: FC<IErrorIconProps> = (
  {
    color = 'var(--accent_negative)',
    size = 21,
    ...props
  }) => {
  const {style, ...rest} = props;
  const commonStyle = {
    flexShrink: 0,
    width: size,
    height: size,
    ...style,
  };

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
         style={commonStyle} {...rest}>
      <path
        d="M5.6875 0C4.56262 0 3.463 0.333566 2.5277 0.958517C1.59239 1.58347 0.863411 2.47173 0.432938 3.51099C0.00246431 4.55024 -0.110167 5.69381 0.109286 6.79708C0.32874 7.90034 0.870422 8.91376 1.66583 9.70917C2.46124 10.5046 3.47466 11.0463 4.57793 11.2657C5.68119 11.4852 6.82476 11.3725 7.86401 10.9421C8.90327 10.5116 9.79154 9.78261 10.4165 8.84731C11.0414 7.912 11.375 6.81238 11.375 5.6875C11.3734 4.17957 10.7737 2.73386 9.70741 1.66759C8.64115 0.601321 7.19543 0.0015924 5.6875 0ZM5.25 3.0625C5.25 2.94647 5.2961 2.83519 5.37814 2.75314C5.46019 2.67109 5.57147 2.625 5.6875 2.625C5.80353 2.625 5.91481 2.67109 5.99686 2.75314C6.07891 2.83519 6.125 2.94647 6.125 3.0625V6.125C6.125 6.24103 6.07891 6.35231 5.99686 6.43436C5.91481 6.51641 5.80353 6.5625 5.6875 6.5625C5.57147 6.5625 5.46019 6.51641 5.37814 6.43436C5.2961 6.35231 5.25 6.24103 5.25 6.125V3.0625ZM5.6875 8.75C5.55771 8.75 5.43083 8.71151 5.32291 8.6394C5.21499 8.56729 5.13088 8.4648 5.08121 8.34489C5.03154 8.22497 5.01854 8.09302 5.04386 7.96572C5.06918 7.83842 5.13169 7.72149 5.22346 7.62971C5.31524 7.53793 5.43217 7.47543 5.55947 7.45011C5.68677 7.42479 5.81872 7.43778 5.93864 7.48745C6.05855 7.53712 6.16104 7.62124 6.23315 7.72916C6.30526 7.83708 6.34375 7.96396 6.34375 8.09375C6.34375 8.2678 6.27461 8.43472 6.15154 8.55779C6.02847 8.68086 5.86155 8.75 5.6875 8.75Z"
        fill={color}/>
    </svg>
  );
};

export default ErrorIcon;





